export function mapAttributesToSortableList(attributes) {
  const mappedAttributes = attributes.map(attr => ({
    dataAttributeKey: attr.dataAttributeKey,
    checked: attr.listDisplayDefault,
    allowed: attr.listDisplayAllowed,
  }));

  return {
    attributes: mappedAttributes,
    items: mappedAttributes.map(attr => attr.dataAttributeKey),
  };
}
